import script from "./Customerdetail-big.vue?vue&type=script&setup=true&lang=js"
export * from "./Customerdetail-big.vue?vue&type=script&setup=true&lang=js"

import "./Customerdetail-big.vue?vue&type=style&index=0&id=a36c5098&lang=css"

const __exports__ = script;

export default __exports__